import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { DEFAULT_DASHBOARD_USER } from '../../dashboard/dashboard.data';
import { DashboardHeaderComponent } from '../../structure/header/header';
import { DashboardSidebarComponent } from '../../structure/sidebar/sidebar';

@Component({
  selector: 'app-ssc-shell',
  standalone: true,
  imports: [CommonModule, DashboardSidebarComponent, DashboardHeaderComponent],
  templateUrl: './ssc-shell.html',
  styleUrl: './ssc-shell.scss',
})
export class SscShellComponent {
  @Input({ required: true }) title = '';

  protected readonly user = DEFAULT_DASHBOARD_USER;
  protected sidebarCollapsed = false;
  protected mobileSidebarOpen = false;

  protected handleMenuToggle(): void {
    if (typeof window !== 'undefined' && window.innerWidth <= 768) {
      this.mobileSidebarOpen = !this.mobileSidebarOpen;
      return;
    }

    this.sidebarCollapsed = !this.sidebarCollapsed;
  }

  protected closeMobileSidebar(): void {
    this.mobileSidebarOpen = false;
  }
}
